"use client";

import * as React from "react";
import { Mascot } from "./mascot";
import { MASCOTS } from "@/lib/mascots";
import { cn } from "@/lib/cn";

/** Giá trị mascot là ảnh (URL/đường dẫn) hay tên mascot dựng sẵn? */
export function isUploadedMascot(value: string | null | undefined): boolean {
  // Tên mascot dựng sẵn là chữ thường không có "/" (vd "star"); còn lại là ảnh:
  // icon đã upload (/api/mascot-assets/…), ảnh học sinh (/api/students/…/avatar), hoặc URL đầy đủ.
  return Boolean(value && (value.startsWith("/") || value.startsWith("http")));
}

/**
 * Hiển thị mascot dù là ảnh upload (URL) hay tên trong bộ dựng sẵn.
 * Dùng chung cho lớp, nhóm, học sinh để đồng nhất cách render.
 */
export function MascotAny({
  value,
  alt = "",
  className,
}: {
  value: string;
  alt?: string;
  className?: string;
}) {
  if (isUploadedMascot(value)) {
    // eslint-disable-next-line @next/next/no-img-element
    return <img src={value} alt={alt} className={cn("size-full object-cover", className)} />;
  }
  const m = MASCOTS[value] ?? MASCOTS.student!;
  return <Mascot name={value} alt={alt} fallback={m.fallback} emoji={m.emoji} className={className} />;
}
